import { FormInput, Loader } from "@/components";
import { Button } from "@/components/ui";
import {
  Card,
  CardContent,
  CardFooter,
  CardHeader,
  CardTitle,
} from "@/components/ui";
import { FormProvider } from "react-hook-form";
import { EMAIL, PASSWORD } from "./consts";
import useLogin from "./useLogin";
import logo from "@/assets/ostwal-logo.png";
import { UserIcon } from "lucide-react";

const Login = () => {
  const {
    form,
    onSubmit,
    requiredFields,
    onEyeIconClick,
    isPassword,
    Icon,
    isLoginPending,
    onForgotClick,
  } = useLogin();
  const { errors } = form.formState;

  return (
    <div className="w-full h-[100vh] bg-[url('/login-bg.png')] bg-no-repeat bg-cover">
      <div className="grid grid-cols-1 md:grid-cols-2 h-full p-[20px] md:p-[50px] lg:p-[80px]">
        <div className="flex items-center justify-center md:items-start md:justify-start">
          <img src={logo} className="w-[120px]" />
        </div>
        <div className="flex items-center justify-center md:justify-end">
          <FormProvider {...form}>
            <form onSubmit={form.handleSubmit(onSubmit)}>
              <Card className="w-full lg:w-[400px]">
                <CardHeader className="my-[20px]">
                  <CardTitle className="text-center font-[500] text-[24px]">
                    Login
                  </CardTitle>
                  <span className="text-[14px] text-g-400 text-center">
                    Access to explore more
                  </span>
                </CardHeader>
                <CardContent>
                  <div className="flex flex-col gap-5">
                    <div>
                      <label className="text-[14px] font-[400]">
                        Email or Mobile No.
                      </label>
                      <FormInput
                        name={EMAIL}
                        control={form.control}
                        placeholder="Please enter"
                        error={errors[EMAIL]?.message}
                        isRequired={requiredFields.includes(EMAIL)}
                        endIcon={<UserIcon className="h-4 w-4" />}
                        type="email"
                      />
                    </div>
                    <div>
                      <label className="text-[14px] font-[400]">Password</label>
                      <FormInput
                        name={PASSWORD}
                        control={form.control}
                        placeholder="Please enter"
                        error={errors[PASSWORD]?.message}
                        isRequired={requiredFields.includes(PASSWORD)}
                        type={isPassword ? "password" : "text"}
                        endIcon={
                          <Icon className="h-4 w-4" onClick={onEyeIconClick} />
                        }
                      />
                    </div>
                    <div className="flex justify-end">
                      <Button
                        type="button"
                        variant="link"
                        className="text-[14px] text-primary text-end p-0 m-0 h-[20px] no-underline font-[400]"
                        onClick={onForgotClick}
                      >
                        Forgot Password?
                      </Button>
                    </div>
                  </div>
                </CardContent>
                <CardFooter>
                  <Button
                    type="submit"
                    className="w-full"
                    disabled={isLoginPending}
                  >
                    {isLoginPending ? <Loader variant="secondary" /> : ""} Login
                  </Button>
                </CardFooter>
              </Card>
            </form>
          </FormProvider>
        </div>
      </div>
    </div>
  );
};

export default Login;
